import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  width: 100%;
  padding: 15px;

  button {
    display: inline-flex;
    color: var(--color-text-brand);
  }
`
